import { render } from "./extend-form.vue?vue&type=template&id=2cd98b2c"
import script from "./extend-form.vue?vue&type=script&lang=js"
export * from "./extend-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__